import { Image } from "react-bootstrap";
import { sanitizeHtml } from "../../utils/sanitizeHtml";

const CircleCard = ({ data }) => {
    return (
        <>
            {data &&
                data.map((d, index) => (
                    <div
                        key={index}
                        className={`col-sm-12 d-flex justify-content-center align-items-center  circle_cardHere ${window.innerWidth > 992 && window.innerWidth < 1200 && index === 3
                            ? "ml-circle"
                            : ""
                            }`}
                    >
                        <div className="circular_card" data-aos="zoom-out-up" data-aos-duration={d.delay}>
                            <div className="card_contain">
                                <div className="d-flex justify-content-center align-items-center">
                                    <Image src={d.icon} alt="" className="img_css" />
                                </div>
                                <p>
                                    <span dangerouslySetInnerHTML={{ __html: sanitizeHtml(d.name) }} />
                                </p>
                            </div>
                        </div>
                    </div>
                ))}

        </>
    )
}

export default CircleCard
